import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, OnDestroy } from '@angular/core';
import { gsap } from 'gsap';
import { LanguageService } from '../language.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ContactComponent implements AfterViewInit, OnDestroy {
  readonly defaultEmail = 'binsztock@proton.me';
  copied = false;
  private copiedTimerId?: number;
  private animationContext?: gsap.Context;

  constructor(
    private readonly elementRef: ElementRef<HTMLElement>,
    public readonly language: LanguageService,
  ) {}

  ngAfterViewInit(): void {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.animationContext = gsap.context(() => {
      gsap.timeline({ defaults: { ease: 'power3.out' } })
        .from('.eyebrow', { autoAlpha: 0, y: 14, duration: .5 })
        .from('h1 span, h1 em', { autoAlpha: 0, y: 42, duration: .95, stagger: .17 }, '-=.25')
        .from('.title-stroke', { scaleX: 0, duration: .75 }, '-=.55')
        .from('.contact-card', { autoAlpha: 0, x: 30, duration: .85 }, '-=.65');
    }, this.elementRef.nativeElement);
  }

  ngOnDestroy(): void {
    this.animationContext?.revert();
    if (this.copiedTimerId) window.clearTimeout(this.copiedTimerId);
  }

  async copyEmail(): Promise<void> {
    try {
      await navigator.clipboard.writeText(this.defaultEmail);
      this.copied = true;

      if (this.copiedTimerId) {
        window.clearTimeout(this.copiedTimerId);
      }

      this.copiedTimerId = window.setTimeout(() => {
        this.copied = false;
      }, 1600);
    } catch {
      this.copied = false;
    }
  }
}
